import { Button } from '@foam/buoy/src/components/Button/Button';
import { Icon } from '@foam/buoy/src/components/Icon/Icon';
import { Popover } from '@foam/buoy/src/components/Popover/Popover';
import { useCallback } from 'react';

import { usePostedBy } from '../../hooks/usePostedBy';
import { useAddContentStore } from '../useAddContentStore';
import { timeframes } from './constants';

export const Posted = () => {
  const { setIsCustomModalOpen } = useAddContentStore();
  const { selectedTime, handleSelectPostedBy, handleReset } = usePostedBy();

  const handleOpenCustomModal = useCallback(() => {
    setIsCustomModalOpen(true);
  }, [setIsCustomModalOpen]);

  return (
    <Popover.Instance placement="bottom-start">
      <Popover.Trigger>
        <Button variant="tertiary" size="lg">
          <Icon name="Calendar" className="size-4" />
          <span className="font-400 text-neutral-500">Posted:</span>
          <span className="text-neutral-900">
            {selectedTime?.friendlyValue}
          </span>
          {selectedTime?.value !== 0 && (
            <span
              role="button"
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleReset(e as unknown as React.MouseEvent<SVGElement>);
              }}
            >
              <Icon name="Close" className="size-4" />
            </span>
          )}
        </Button>
      </Popover.Trigger>
      <Popover.Root size="hug" modal={false} className="!p-2">
        <ul className="flex flex-col">
          {timeframes.map((t) => (
            <li key={t.value}>
              <Popover.Dismiss
                render={
                  <button
                    type="button"
                    className="w-full cursor-pointer rounded-4 px-4 py-2 text-left text-14 hover:bg-neutral-50"
                    onClick={() => handleSelectPostedBy(t.value)}
                  >
                    {t.friendlyValue}
                  </button>
                }
              />
            </li>
          ))}
          <li>
            <Popover.Dismiss
              render={
                <button
                  type="button"
                  className="w-full cursor-pointer rounded-4 px-4 py-2 text-left text-14 hover:bg-neutral-50"
                  onClick={handleOpenCustomModal}
                >
                  Custom
                </button>
              }
            />
          </li>
        </ul>
      </Popover.Root>
    </Popover.Instance>
  );
};
